export const isArrayLike = (<T>(x: any): x is ArrayLike<T> => x && typeof x.length === 'number');


// WEBPACK FOOTER //
// ../../src/util/isArrayLike.ts